import { ChangeEvent, FormEvent, memo, useState } from "react";
import style from "./index.module.scss";

export type CardTokenAction = "activate" | "deactivate";

interface CardTokenActionModalProps {
  action: CardTokenAction;
  isSubmitting: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

const COPY: Record<
  CardTokenAction,
  { title: string; description?: string; confirmLabel: string }
> = {
  activate: {
    title: "Activate this card token?",
    confirmLabel: "Activate token",
  },
  deactivate: {
    title: "Deactivate this card token?",
    description:
      "This action is permanent — StraitsX does not allow reactivating a deactivated token.",
    confirmLabel: "Deactivate token",
  },
};

function CardTokenActionModal(props: CardTokenActionModalProps) {
  const [reason, setReason] = useState("");
  const copy = COPY[props.action];

  const handleChangeReason = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setReason(e.target.value);
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (reason.trim()) {
      props.onConfirm(reason.trim());
    }
  };

  return (
    <div className={style.formWrapper}>
      <div className={style.formHeading}>
        <h1 className={style.title}>{copy.title}</h1>
        {copy.description && (
          <p className={style.description}>{copy.description}</p>
        )}
      </div>
      <form className={style.formContent} onSubmit={handleSubmit}>
        <textarea
          autoFocus
          placeholder="Reason (required)"
          className={style.textarea}
          value={reason}
          onChange={handleChangeReason}
        />
        <div className={style.buttonsWrapper}>
          <button
            disabled={!reason.trim() || props.isSubmitting}
            type="submit"
            className={style.submitButton}
          >
            {props.isSubmitting ? "Submitting..." : copy.confirmLabel}
          </button>
          <button
            type="button"
            className={style.cancelButton}
            onClick={props.onCancel}
            disabled={props.isSubmitting}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default memo(CardTokenActionModal);
